<script lang="ts" setup>
// -------------------------------
// 🔹 Imports Vue & composables
// -------------------------------
import { form, isLoaderLoginFormActivated } from '../../refs/login.form.refs';
import { isCategoryActivated } from '@/refs/categories.refs';

// -------------------------------
// 🔹 Composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';

// -------------------------------
// 🔹 Refs & données
// -------------------------------
import { idToDelete } from '@/refs/commerce.refs';
import { isGlobalError, restauantIdVal } from '@/refs/common.refs';

// -------------------------------
// 🔹 Mutations / services
// -------------------------------
import { UserMutation } from '@/mutations/user.mutation';
import {
  form_Client_user_Body,
  form_user_Body,
  form_user_Body_update,
  isAtcivatedWatch,
  isAtcivatedWatchUser,
} from '@/refs/user.refs';
import { useQuery } from '@tanstack/vue-query';
import { useCommerceStore } from '@/store/commerce.store';
const { handleCreateUser, updateUserInfos } = UserMutation();

// -------------------------------
// 🔹 Émission d’événements
// -------------------------------
const emit = defineEmits<{
  (e: 'HandleClose'): void;
}>();

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const commerceStore = useCommerceStore();

const {
  data: dataGetCommerces,
  isLoading: isLoadingGetCommerces,
  isError: isErrorGetCommerces,
  refetch: refectGetCommerces,
} = useQuery({
  queryKey: ['GetCommerces'],
  queryFn: () => commerceStore.getCommerces(),
});
// -------------------------------
// 🔹 Gestion du formulaire
// -------------------------------

/**
 * Soumet le formulaire de création de commerce.
 * Gère les différentes étapes : création du commerce, ajout du contact, ou upload du logo.
 */
const handleSubmit = async () => {
  isLoaderLoginFormActivated.value = true;

  try {
    const res = await updateUserInfos({
      email: form_user_Body_update.email,
      firstname: form_user_Body_update.firstname,
      lastname: form_user_Body_update.lastname,
      phone: form_user_Body_update.phone,
      fullname:
        form_user_Body_update.firstname + ' ' + form_user_Body_update.lastname,
    });

    if (res) {
      setTimeout(() => {
        isAtcivatedWatchUser.value = !isAtcivatedWatchUser.value;
        isLoaderLoginFormActivated.value = false;
        handleClose();
      }, 1000);
    }
  } catch (error) {
    isGlobalError.value = true;
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
      isGlobalError.value = false;
    }, 1000);
  }
};

/**
 * Ferme le formulaire et réinitialise l’ID à supprimer.
 */
const handleClose = (): void => {
  idToDelete.value = null;
  emit('HandleClose');
};
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div class="space-y-[16px]">
      <TextInput
        required="true"
        v-model="form_user_Body_update.email"
        name="Entrez l'adresse e-mail de l'utilisateur"
        placeholder="Entrez l'adresse e-mail de l'utilisateur"
        type="text"
        id="Entrez l'adresse e-mail de l'utilisateur"
        label="Entrez l'adresse e-mail de l'utilisateur"
      />
      <TextInput
        required="true"
        v-model="form_user_Body_update.lastname"
        name="Entrez le nom de l'utilisateur"
        placeholder="Entrez le nom de l'utilisateur"
        type="text"
        id="Entrez le nom de l'utilisateur"
        label="Entrez le nom de l'utilisateur"
      />

      <TextInput
        required="true"
        v-model="form_user_Body_update.firstname"
        name="Entrez le prénom de l'utilisateur"
        placeholder="Entrez le prénom de l'utilisateur"
        type="text"
        id="Entrez le prénom de l'utilisateur"
        label="Entrez le prénom de l'utilisateur"
      />
      <TextInput
        required="true"
        v-model="form_user_Body_update.phone"
        name="Entrez le numéro de téléphone de l'utilisateur"
        placeholder="Entrez le numéro de téléphone de l'utilisateur"
        type="text"
        id="Entrez le numéro de téléphone de l'utilisateur"
        label="Entrez le numéro de téléphone de l'utilisateur"
      />

      <!-- <TextInput
        required="true"
        v-model="form_user_Body.password"
        name="Entrez le mot de passe de l'utilisateur"
        placeholder="Entrez le mot de passe de l'utilisateur"
        type="text"
        id="Entrez le mot de passe de l'utilisateur"
        label="Entrez le mot de passe de l'utilisateur"
      /> -->

      <!-- <div class="flex flex-1 flex-col gap-2 w-full">
        <label for="commerce" class="block mb-1 font-medium text-gray-700">
          Sélectionnez le commerce<span class="text-decroissance text-14px leadinspanrmal"
            >*</span
          >
        </label>
        <select
          id="commerce"
          name="commerce_associé"
          v-model="form_user_Body.restaurantId"
          required
          class="w-full px-3 py-2 rounded-xl border border-border-input bg-white text-gray-700 text-sm placeholder-gray-400 shadow-sm outline-none transition-all focus:ring-2 focus:ring-primary-900 focus:border-primary-900 hover:border-gray-400"
        >
          <option value="" disabled>Veuillez sélectionner un commerce</option>
          <option
            v-for="value in dataGetCommerces?.data"
            :value="value?.id"
            class="text-14px text-secondary-text"
          >
            {{ value.designation }}
          </option>
        </select>
      </div> -->
    </div>

    <div class="invisible h-[50px]" />

    <div class="fixed bottom-0 left-0 w-full bg-white py-6">
      <div class="flex flex-row items-center justify-between gap-8 px-[16px]">
        <div class="w-full">
          <BaseButtonPrimary
            type="submit"
            :isClicked="isLoaderLoginFormActivated"
            :label="'Modifier les informations de l\'utilisateur'"
            style_of_btn="primary_color_of_btn "
            class="w-full text-white"
          />
        </div>

        <div class="w-full" @click="handleClose">
          <BaseButtonPrimary
            type="button"
            label="Annuler"
            style_of_btn="secondary_color_of_btn "
            class="text-grand-text w-full"
          />
        </div>
      </div>
    </div>
  </form>
</template>
